/*******************************************************************
* PAGE        : AmcWarrantyManagementList
* REMARKS     :
* CREATED ON  : 19-05-2026
* AUTHOR      : Gurjar.Sonal
* MODIFY      : 
* MODIFY ON   : 
********************************************************************/

import React, { useEffect, useState } from 'react';
import SnackbarsComponent from '../../components/SnackbarsComponent/SnackbarsComponent';
import ListComponent from '../../components/ListComponent/ListComponent';
import CommonModal from '../../components/ModalComponent/CommonModal';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TabComponent from '../../components/TabComponent/TabComponent';
import AmcWarrantyManagamentDetailsPage from './AmcWarrantyManagamentDetailsPage';
import CustomTabComponent from '../../components/CustomTabComponent/CustomTabComponent';
import TitleComponent from '../../components/TitleComponent/TitleComponent';
import { CMExpressAPIAMCDetailsGet } from '../../services/apiController';

// #region Component
const AmcWarrantyManagementList = () => {

    // #region States

    const userIdentification = useSelector(s => s.reduxMaster.userMasterIdentification);

    const location = useLocation(); // To track the current location/path of the page
    const SidebarMENU = useSelector(s => s.reduxMaster.masterArray?.SidebarMENU);
    const menuName = SidebarMENU.find(m => m.PageUrl === location.pathname);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    const next15Days = new Date(today);
    next15Days.setDate(next15Days.getDate() + 15);

    const [loading, setLoading] = useState(false);  // State to manage loading status
    const [allData, setAllData] = useState([]);  // State to store all the data
    const [listData, setListData] = useState([]);  // State to store the list of data

    const [activeTab, setActiveTab] = useState("1");

    const [initialStates, setInitialStates] = useState({ PopupTitle: "", PopupActionText: "", PopupAction: "", EditID: "", PopupOpen: "" }); // Initial states for the modal and popup data

    // Close the snackbar after a specified time
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' }); // Snackbar state for showing messages like success or error
    const handleCloseSnackbar = (status) => { setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' }); };

    // Header buttons configuration (like Add User, Sync)  menuName?.IsAllowAdd ? 101 : null
    const headerButtons = [
        // { id: 102, name: "Download to CSV", color: "primary", size: "medium", type: 'icon', fileExtension: '.csv' },
        { id: 103, name: "Send Reminder", color: "primary", size: "small", type: 'button' }
    ];

    // Data for the grid columns configuration
    const gridColumnsData = [
        { label: "Customer Name", name: "AccountName", actionType: 2, minWidth: "250px", },
        { label: "Product Name", name: "ItemName", actionType: 2, minWidth: "250px", },
        { label: "Item Code", name: "ItemCode", actionType: 2, minWidth: "80px", },
        {
            label: "Actions", name: "actions", minWidth: "50px", textAlign: 'center', actionType: 1,
            actionButtons: [
                { id: 101, name: 'View', color: "primary", size: "18px", type: 'icon' },
                ...(activeTab === "0" ? [{ id: 5, name: 'CheckBox', color: "primary", size: "18px", type: 'action', checkBoxKey: 'selected' }] : []),
            ]
        }
    ];
    // #endregion

    //#region API Call
    useEffect(() => {
        wsCMExpressAPIAMCDetailsGet();
    }, []);

    const wsCMExpressAPIAMCDetailsGet = async () => {
        setLoading(true);

        const payloadBody = {
            isMobileUser: 'false',
            strUserIdentification: userIdentification
        };

        try {
            const response = await CMExpressAPIAMCDetailsGet(payloadBody);
            if (response.status) {
                const modifiedData = response.data.map(item => (item.ToPeriodDate === "2023-03-25T00:00:00" ? { ...item, id: item.AMCDetailsId, ToPeriodDate: "2026-06-26T00:00:00", WarrantyStatus: "In AMC" } : { ...item, id: item.AMCDetailsId }));

                setAllData(modifiedData);

                // Default tab = Overdue
                const overdueData = modifiedData.filter(item => {
                    const toDate = new Date(item.ToPeriodDate);
                    return toDate < today && toDate >= oneYearAgo;;
                });

                setListData(overdueData);
            }
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };

    //#endregion

    //#region handler function
    // Function to handle action button click (Add, View, Edit, Delete, Sync)
    const handleActionBtnClick = ((btnId, eleId, ele) => {
        if (btnId == 101) { // View AMC Managament
            // const data = activeTab == "2" ? UpcomingAMCWarrantyList[eleId] : OverdueAMCWarrantyList[eleId];
            // setAllDetails(data)
            setInitialStates({ ...initialStates, Action: 3, PopupTitle: 'AMC / Warranty Managament Details', PopupActionText: 'Save', PopupAction: 'View', EditID: 0, DetailedData: ele, PopupOpen: true });
        } else if (btnId == 203) {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: 'Send Renewal Successfully.', snackbarSeverity: 'success' });
            window.location.reload();
        }
    });

    // Function to close the modal
    const handleCloseModal = () => setInitialStates({ ...initialStates, PopupOpen: false });

    const TabData = [
        { id: "1", label: 'Overdue AMC' },
        { id: "2", label: 'Upcoming AMC' },
        { id: "3", label: 'Active AMC' },
    ];

    // Handle Tab Change (When a tab is clicked)
    const handleTabChange = (id) => {
        setActiveTab(id);
        let filteredData = [];

        switch (id) {
            case "1": // Overdue AMC
                filteredData = allData.filter(item => {
                    const toDate = new Date(item.ToPeriodDate);

                    return toDate < today && toDate >= oneYearAgo;
                });
                break;

            case "2": // Upcoming AMC
                filteredData = allData.filter(item => {
                    const toDate = new Date(item.ToPeriodDate);

                    return toDate >= today && toDate <= next15Days;
                });
                break;

            case "3": // Active AMC
                filteredData = allData.filter(item => {
                    const fromDate = new Date(item.FromPeriodDate);
                    const toDate = new Date(item.ToPeriodDate);

                    return fromDate <= today && toDate >= today;
                });
                break;

            default: filteredData = [];
        }

        setListData(filteredData);
    };

    const handleDelete = () => {
        setInitialStates({ ...initialStates, PopupOpen: false });
        setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: 'Complaint close successfully', snackbarSeverity: 'success' });
        // alert("Close: " + initialStates.EditID); // Handle close action (can be customized)
    };

    // #endregion

    return (
        <React.Fragment>
            {/* Snackbar notification for success/failure messages */}
            <SnackbarsComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

            <div className='page-title-with-tab'>
                <TitleComponent Title={"AMC / Warranty Management"} />
                <CustomTabComponent TabData={TabData} activeTabId={activeTab} onClick={handleTabChange} />
            </div>

            {/* ListComponent for displaying AMC / Warranty Managament */}
            <ListComponent
                gridColumns={gridColumnsData}
                gridData={listData}
                isLoading={loading}
                headerButtons={headerButtons}
                handleActionBtnClick={handleActionBtnClick}
            />

            {/* Modal for Add/Edit/View/Delete AMC / Warranty Managament */}
            {initialStates.PopupOpen &&
                <CommonModal
                    maxWidth={'md'}
                    Title={initialStates.PopupTitle}
                    ActionText={initialStates.PopupActionText}
                    IsDeletePopup={initialStates.Action == 1 ? true : false}
                    IsLoading={initialStates.loading}
                    onClose={handleCloseModal.bind(this)}
                    onSave={handleDelete.bind(this)}
                    disableOuterClick={true}
                    IsScroll
                >
                    <AmcWarrantyManagamentDetailsPage DetailedData={initialStates.DetailedData} setSnackbarStates={setSnackbarStates} handleCloseModal={handleCloseModal} />
                </CommonModal>}

        </React.Fragment>
    );
};
// #endregion

export default AmcWarrantyManagementList;